import React, { Component } from 'react'
import { Button } from 'semantic-ui-react'
import { Collapse } from 'react-collapse'
import PropTypes from 'prop-types'

export default class Expandable extends Component {
	constructor(props) {
		super()
		this.state = {
			isOpened: Boolean(props.startOpen)
		}
		this.toggleOpen = this.toggleOpen.bind(this)
	}

	toggleOpen() {
		this.setState(state => ({
			isOpened: !state.isOpened
		}))
	}

	render() {
		return (
			<div className="expandable-container">
				<Button
					secondary
					onClick={this.toggleOpen}
					icon={`chevron ${this.state.isOpened ? 'down' : 'right'}`}
					content={this.props.buttonText}
				/>
				<Collapse isOpened={this.state.isOpened}>{this.props.children}</Collapse>
			</div>
		)
	}
}
Expandable.propTypes = {
	buttonText: PropTypes.string.isRequired,
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
		.isRequired,
	startOpen: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/Expandable.js